import { anyFile, dicom, imageFile, pdfFile } from '@/components/icons/icons';
import { find } from 'lodash';
import { stringify as uuidStringify } from 'uuid';

const mapList = [
  { key: 'pdf', icon: pdfFile },
  { key: 'image/', icon: imageFile },
  { key: 'unknown', icon: anyFile },
  { key: '/dicom', icon: dicom },
];

export const iconMapper = (type: string | undefined | null) =>
  type ? find(mapList, (mapItem) => type?.includes(mapItem.key))?.icon || anyFile : anyFile;

function hexStringToByteArray(hexString: string) {
  if (hexString.length % 2 !== 0) {
    return [];
  }
  const numBytes = hexString.length / 2;
  const byteArray = new Uint8Array(numBytes);
  for (let i = 0; i < numBytes; i++) {
    const partStr = hexString.substring(i * 2, i * 2 + 2);
    byteArray[i] = parseInt(partStr, 16);
  }
  return byteArray;
}

export const extractUuidFromUrl = (urlWithId: string) => {
  const urlParts = urlWithId.split('/');
  const idText = urlParts[urlParts.length - 1];
  return uuidStringify(Array.from(hexStringToByteArray(idText)));
};
